<template>
    <div class="rsvp">
        <div class="rsvp_content">
            <div class="form_rsvp">
                <br>
                <img src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Delgado%20Calles%2FRSVP.png?alt=media&token=1a1f1c9b-44e4-4d33-8a85-8c6cdce453bd" id="imagenPrincipal">
                <button id="btn-Confirmar" @click="goToProduct('https://api.whatsapp.com/send?phone=78887603')">Confirmar aquí</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {

     

    name: 'RSVP',
    props: {
        Code: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            email: "",
            message: "",
            phone: "",
            num: "",
            Invitado: this.$route.query.invitado,
            Cantidad: parseInt(this.$route.query.cantidad),
        }
    },
    methods: {
        create() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}rsvp/CreateRSVP/${this.Code}` : `${process.env.VUE_APP_API_PRO}rsvp/CreateRSVP/${this.Code}`;
            let data = {
                name: this.Invitado,
                num: this.num,
                message: this.message
            }
            axios.post(url, data)
                .then((response) => {
                    if (response.status == 200) {
                        Swal.fire(
                            '',
                            'Muchas gracias por confirmar',
                            'success'
                        );
                    }
                    this.name = "";
                    this.email = "";
                    this.num = "";
                    this.message = "";
                    this.phone = "";
                })
                .catch(err => console.error(err));
        },

        goToProduct(link) {
            console.log(link);
            window.open(link, '_blank');
        },

        notAttend() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}rsvp/NotAttend/${this.Code}` : `${process.env.VUE_APP_API_PRO}rsvp/NotAttend/${this.Code}`;
            let data = {
                name: this.Invitado,
            }
            axios.post(url, data)
                .then((response) => {
                    if (response.status == 200) {
                        Swal.fire(
                            '',
                            'Muchas gracias por confirmar',
                            'success'
                        );
                    }
                    this.name = "";
                    this.email = "";
                    this.num = "";
                    this.message = "";
                    this.phone = "";
                })
                .catch(err => console.error(err));
        }

    },
}
</script>

<style scoped>
.rsvp {

    width: 85%;
    color: var(--text);
}

.rsvp_content {
    width: 30%;
    margin: 79px auto;
    display: grid;
}

.form_rsvp {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    place-items: center;
    background-color: #fff;
    /* box-shadow: 12px 0 35px -13px #cdcdcd, -12px 0 35px -13px #cdcdcd; */
    padding-bottom: 1rem;
}

button {
    background-color: rgb(187, 148, 106);
    border-radius: 0.5rem;
    box-shadow: var(--btn-shadow);
}

button:hover {
    box-shadow: var(--btn-shadow-hover);
}

button:active {
    box-shadow: var(--btn-shadow-active);
}

input[type=text] {
    width: 90%;
}

textarea {
    width: 90%;
}

.selectForm {
    width: 90%;
    color: #6b8181;
}

#logo {
    padding-top: 1rem;
    width: 5rem;
}

#btn-Confirmar {
    background: var(--btn);
    color: var(--btn-text);
    border-radius: 6px;
    box-shadow: var(--btn-shadow);
    height: 2.7rem;
    margin-top: -6rem;
    font-weight: 600;
    font-size: 16px;
}

#imagenPrincipal{
    width: 100%;
}


@media (max-width: 768px) {
    .rsvp_content {
        width: 100%;
    }

    /* .rsvp {
       
        
    } */

    #imagenPrincipal{
    width: 100%;
}
}
</style>
